import  Module, { ViewLayer, moduleInit }  from "../../../../framework/core/mvvm/module_base"
import TableMatchView from "./table_match_view";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData from "../../../public/model_data";
import SceneManager from "../../../../manager/scene_manager";
import * as ProtoLogin from "../../../hall/server/hall/proto_hall"
import HallServer from "../../../hall/server/hall/hall_serve";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("TableMatchModule")
export default class TableMatchModule<V extends TableMatchView> extends Module<V,null>  {

    private lastRequestJoinTime = 0

    private matchRoomSucess = false

    constructor(){

        super();
        this.layer = ViewLayer.High;
        this.viewType = TableMatchView;
        //this.modelType = TableMatchModel;
        this.windowPrefabResPath = "package/table/table_match";
        //this.windowPrefabResPath = "package/public/dialog_tips";
        this.registerMsg();
    }

    public onShow(intentData?: any){

        ModuleManager.instance.hideModule("NetPrompt")
        super.onShow(intentData);
        this.matchRoomSucess = false
        this.needViewMask = true;    
        this.lastRequestJoinTime = 0
        this.schedule(this.pingCallback, 4)
        this.schedule(this.pingCheck, 1)
    }

    registerMsg() {
        super.registerMsg()
        this.eventBind("Event_GoldMatching_Quit",this.on_gold_quit_rsp,);
        this.eventBind("Event_GoldMatching_Notify_RoomInfo",this.on_gold_roominfo_notify,);
        
    }

    private pingCheck() {
        HallServer.instance.checkHeartBeatTimeOut(8)
    }

    private pingCallback() {
        if (HallServer.instance.netClient.netState && this.view && this.view.isValid) {
            HallServer.instance.request_ping();
        }
        else {
            this.unscheduleAllCallbacks()
        }
    }

    private on_gold_quit_rsp(protoData: ProtoLogin.Auth.RSP_GoldQuit) {
        if (!this.nodeIsActive) {
            return;
        }
        // if (ModelData.instance.tableCommonData.qualifyId) {
        //     SceneManager.gotoHall()
        //     return
        // }        

        if (protoData.ErrorCode != 0) {
            HallServer.instance.setMatchingGoldErrorState()
            HallServer.instance.reconnectServer()
            return;
        }

        SceneManager.gotoHallOrClubHall("TabelExit");                      
      
    }

    public onButtonClickName(name : string){
        
        switch (name) {
            case "CloseBtn":
            case "Button_Close": 
                //代表没有连接上，因为判断是在click上面
                if (!this.matchRoomSucess && !HallServer.instance.netClient.netState) {
                    SceneManager.gotoHallOrClubHall("TabelExit");   
                    return
                }
                let goldId = ModelData.instance.tableCommonData.goldFildId;
                let userId = ModelData.instance.roleData.id  
                let qualitfyId = ModelData.instance.tableCommonData.qualifyId;        
                HallServer.instance.request_goldmathing_quit(goldId, userId, qualitfyId)

            break;                    
        }
    }

    private on_gold_roominfo_notify(protoData: ProtoLogin.Auth.Notify_GoldRoomInfo) {
        
        if (!this.view) {
            this.AddHandleToWaitDealQueue(this.on_gold_roominfo_notify, protoData, this);
            return;
        }
        if (protoData.RoomID && protoData.RoomID != 0) {
            if(this.matchRoomSucess){
                return
            }
            this.matchRoomSucess = true
            let data = {
                Password: protoData.Password,
                ServerHost: protoData.Host,
                wsport: protoData.Port,
                RoomID: protoData.RoomID,
                Rule: protoData.PlayRule,
                GoldFieldID: ModelData.instance.tableCommonData.goldFildId,
            }
            HallServer.instance.do_enterRoom(data)
            // let now = Date.now()
            // if (now - this.lastRequestJoinTime >= 3000) {
            //     this.matchRoomSucess = true
            //     // cc.log("金币场请求加入房间:", protoData.RoomID)
            //     ModelData.instance.tableCommonData.tableType = 1
            //     this.lastRequestJoinTime = now
            //     HallServer.instance.joinRoom(protoData.RoomID)
            // }
        } 
    }

 
}
